import React, { useEffect, useState } from 'react'
import { useParams, useNavigate, Link } from 'react-router-dom';
import axios from "axios";
import BgImage from "../../images/practiceArea/agreement.jpeg";

const ArticleDetails = () => {
  const { articleId } = useParams();
  const navigate = useNavigate();
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchArticles = async () => {
      try {
        const response = await axios.get("https://backend.lawberonlegals.com/api/articles");
        setArticles(response.data);
      } catch (err) {
        setError("Failed to load article, check your internet connection and refresh the page.");
      } finally {
        setLoading(false);
      }
    };

    fetchArticles();
  }, []);

  const article = articles?.find(article => article.title.toLowerCase().replace(/\s+/g, '-') === articleId);

  useEffect(() => {
    if (articles?.length > 0) {
      if (!articleId || !articles.some(article => article.title.toLowerCase().replace(/\s+/g, '-') === articleId)) {
        navigate("/insights");
      }
    }
  }, [articleId, articles, navigate]);

  return (
    <div>
      <section className="relative h-[400px] md:h-[450px] flex items-center bg-cover bg-center"
        style={{
          backgroundImage: `linear-gradient(rgba(5, 33, 55, 0.9), rgba(5, 33, 55, 0.9)), url(${BgImage})`,
        }}>
        <div className="container mx-auto px-6 text-center">
          <h1 className="text-[14px] md:text-[17px] text-white mb-4">{article?.title}</h1>
          <div className="mt-8 flex justify-center gap-4">
            <Link to="/book" className="bg-transparent border-2 border-white hover:bg-white hover:text-blue-900 text-white font-semibold py-2 px-4 rounded-xl shadow-lg transition duration-300">
              Speak with a consultant
            </Link>
          </div>
        </div>
      </section>
      <section className="px-[6%] my-6">
        {loading && (
          <p className="text-center text-lg font-semibold">Loading article...</p>
        )}
        {error && (
          <p className="text-center text-red-500">{error}</p>
        )}
        <div
          className="text-gray-700"
          dangerouslySetInnerHTML={{ __html: article?.articleContent }} // Renders HTML content
        />
      </section>
    </div>
  )
}

export default ArticleDetails;
